export async function getAsesores(id){
    return new Promise((resolve) => {
        var datos = [
            {nombre:'CI TALSA ANTIOQUIA', asesor:{nombre:"Blanca Milena Bonilla",correo:"blanca.bonilla@talsa.com.co",telefono:"+57 3244071621"}},
            {nombre:'CI TALSA CENTRO', asesor:{nombre:"Diego Arley Flórez Tocasuche",correo:"diegoarley.florez@talsa.com.co",telefono:"+57 3244071621"}},
            {nombre:'CI TALSA OCCIDENTE', asesor:{nombre:"Blanca Milena Bonilla",correo:"blanca.bonilla@talsa.com.co",telefono:"+57 3244071621"}},
            {nombre:'CI TALSA COSTA', asesor:{nombre:"Katherine Paola Solano Osorio",correo:"katherine.solano@talsa.com.co",telefono:"+57 3244071621"}},
            {nombre:'CI TALSA EJE CAFETERO', asesor:{nombre:"Blanca Milena Bonilla",correo:"blanca.bonilla@talsa.com.co",telefono:"+57 3244071621"}},
            {nombre:'CI TALSA SANTANDER', asesor:{nombre:"Angela Paola Mantilla Herrera",correo:"angela.mantilla@talsa.com.co",telefono:"+57 3244071621"}},
            {nombre:'CI TALSA NORTE SANTANDER', asesor:{nombre:"Angela Paola Mantilla Herrera",correo:"angela.mantilla@talsa.com.co",telefono:"+57 3244071621"}},
            {nombre:'SUPERMERCADO ANTIOQUIA', asesor:{nombre:"Juan Camilo Gutierrez",correo:"juan.gutierrez@talsa.com.co",telefono:"+57 3044631108"}},
            {nombre:'SUPERMERCADO CENTRO', asesor:{nombre:"Alexander Pinilla Garzon",correo:"alexander.pinilla@talsa.com.co",telefono:"+57 3102017897"}},
            {nombre:'SUPERMERCADO OCCIDENTE', asesor:{nombre:"Luz Elena Carvajal",correo:"luz.carvajal@talsa.com.co",telefono:"+57 3174394591"}},
            {nombre:'SUPERMERCADO COSTA', asesor:{nombre:"Rosalba Rojas Romero Martinez",correo:"osalba.rojas@talsa.com.co",telefono:"+57 3173311389"}},
            {nombre:'SUPERMERCADO EJE CAFETERO', asesor:{nombre:"Diego Fernando Valencia Pavas",correo:"diego.valencia@talsa.com.co",telefono:"+57 3183476180"}},
            {nombre:'SUPERMERCADO SANTANDER', asesor:{nombre:"Yerson Acosta Marroquin",correo:"yerson.acosta@talsa.com.co",telefono:"+57 3173645669"}},
            {nombre:'SUPERMERCADO NORTE SANTANDER', asesor:{nombre:"Jorge Villamizar",correo:"jorge.villamizar@talsa.com.co",telefono:"+57 3176372321"}},
        ] 
        var asesor = false;
        var url = id
        datos.forEach(element => {
            if(element.nombre === id){
                asesor = true;
                url = element.asesor
            }
        });

        if(asesor){
            resolve(url)
        }else{
            resolve(false)
        }
    })
}